(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  function updateSingleVisibleProductLayout() {
    document.querySelectorAll('results-list').forEach((resultsList) => {
      const grid = resultsList.querySelector('.product-grid');
      if (!grid) return;

      const visibleItems = Array.from(
        grid.querySelectorAll('.product-grid__item')
      ).filter((item) => {
        const style = window.getComputedStyle(item);
        return (
          !item.hidden &&
          style.display !== 'none' &&
          style.visibility !== 'hidden'
        );
      });

      grid.classList.toggle('product-grid--single-visible', visibleItems.length === 1);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    updateSingleVisibleProductLayout();

    document.querySelectorAll('results-list').forEach((resultsList) => {
      const observer = new MutationObserver(() => {
        updateSingleVisibleProductLayout();
      });

      observer.observe(resultsList, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden']
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
